import { useContext, useEffect } from 'react';

import { LayoutContext } from '@shared/contexts';

import type { TAiAssistantOrigin } from '../types';

export const useRegisterAiAssistantOrigin = (origin: TAiAssistantOrigin | undefined) => {
  const { setCurrentOrigin } = useContext(LayoutContext);
  useEffect(() => {
    setCurrentOrigin(origin);
    return () => setCurrentOrigin(undefined);
  }, [origin?.item, origin?.itemType, setCurrentOrigin]);
};
